// @ts-check
import { getColor } from 'common/constants/_colors';
import { DAYS_PARAM, TRACKING } from 'common/constants/constants';
import { premiumRequest } from 'common/services/general.service';
import * as TrackingService from 'common/services/tracking.service';
import { navigateBookDemoClick } from 'common/utils/utils';
import { Flex } from 'components/base/layout-components';
import moment from 'moment';
import styled from 'styled-components';
import Icon from './base/Icon';
import { Inline } from './base/Text';
import { LBButton } from '@linearb/buzz';

const ZebraSection = styled(Flex)`
  padding: 1rem;
  margin-bottom: 1rem;
  background: url('/img/zebra.png') ${getColor('white')};
`;

const TrialBar = ({ account, organization }) => {
  const openPremiumRequest = async () => {
    await premiumRequest();

    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.PREMIUM,
      name: account.name,
      email: account.email,
      org: organization.name,
      org_id: organization.id
    });

    navigateBookDemoClick();
  };

  if (!organization || !account) {
    return null;
  }
  const daysToEndTrial =
    moment(organization.license.end_date).diff(moment(), DAYS_PARAM) + 1;
  return (
    <ZebraSection
      height='100%'
      justify='space-between'
      items='center'
      content='center'
    >
      <Flex
        height='100%'
        justify='space-between'
        items='center'
        content='center'
      >
        <Icon name='trialicon' color='black' size='large' />
        <Inline pl='1rem' size='large' weight='600' color='chambray'>
          Your trial will expire{' '}
          {daysToEndTrial === 1 ? 'Tomorrow' : `in ${daysToEndTrial} days`}.
          During the trial you have access to all features in the system.
        </Inline>
      </Flex>

      <LBButton size='lg' onClick={openPremiumRequest}>
        Upgrade Now
      </LBButton>
    </ZebraSection>
  );
};

export default TrialBar;
